import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, ProgressBar, PageHeader, Tabs, Tab } from 'react-bootstrap';

import request from 'superagent';
import NetDocumentsCabinetProfileConfig from './NetDocumentsCabinetProfileConfig';

class NetDocumentsCabinetsConfig extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number.isRequired,
  };

  initialState = {
    loading: true,
    cabinets: [],
  };

  state = { ... this.initialState };

  componentDidMount() {
    this.fetchCabinets();
  }

  fetchCabinets(refreshFromNetdocs) {
    console.log(`Refreshing Cabinet List for ${this.props.connectionId}`);
    this.setState(this.initialState);
    // Fetch Cabinets
    request
      .get(`/rpc/integrations/connections/${this.props.connectionId}/cabinets`)
      .query({ refresh: refreshFromNetdocs })
      .then(
        (res) => {
          this.setState({ loading: false, cabinets: res.body.cabinets });
        },
        (errRes) => {
          this.setState({ loading: false });
        }
      );
  }


  render() {
    return (
      <div style={{ marginBottom: '360px' /* for attribute menus to not cause scrolling */}}>
        <PageHeader>NetDocuments Cabinet Profiles</PageHeader>

        <Alert bsStyle="warning">
          Your account is connected to NetDocuments.
          Each cabinet that should receive a copy of files needs be properly configured below.
          Please change these values only as directed by CourtDrive engineers.
          If you are experiencing issues, please contact CourtDrive Support.
        </Alert>

        {this.state.loading
          ? <ProgressBar active now={100} />
          : <Tabs animation={false}>{ this.state.cabinets.map((cabinet, index) =>
              <Tab eventKey={index} title={<span><i className="fa fa-archive"/> {cabinet.name} </span>}>
                <NetDocumentsCabinetProfileConfig
                        connectionId={this.props.connectionId}
                        cabinet={cabinet}
                      />
              </Tab>
            )}</Tabs>

        }

        <Button bsStyle="link" bsSize="xsmall" onClick={ () => this.fetchCabinets(true) }>Refresh Cabinets</Button>
      </div>
    );
  }
}

export default NetDocumentsCabinetsConfig;



// WEBPACK FOOTER //
// ./src/Integrations/connections/NetDocumentsCabinetsConfig.jsx